<template>
  <div class="md-layout category-item">
    <div class="md-layout-item md-size-100 category d-flex justify-content-between" @click.prevent="toggleExpand">
      <div class="d-flex align-items-center category-name">■ {{ category.name }}</div>
      <md-icon v-if="is_expand" style="margin: 0">expand_less</md-icon>
      <md-icon v-else style="margin: 0">expand_more</md-icon>
    </div>
    <div class="md-layout-item md-size-100 faqs" :style="faq_style" ref="faqContentBox">
      <div v-for="faq in category.filteredFaqs" :key="'faq-' + category.id + '-' + faq.id" class="faq">
        <div class="d-flex" style="font-weight: bold; margin-top:10px;">
            <div class="question">Q</div>
            <div class="question-content" v-html="faq.question"></div>
        </div>
        <div class="d-flex" style="margin-top:10px;">
          <div class="answer">A</div>
          <div class="answer-content" v-html="faq.answer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name : 'FaqCategoryItem',
  props: [
    'category',
  ],
  data: function() {
    return {
      is_expand: 0,
      computeHeight: 0,
      faq_style: {}
    }
  },
  watch: {
    category: function (newCategory) {
      this.is_expand = newCategory.expanded;
    }
  },
  created: function() {
    this.is_expand = this.category.expanded;
    this.faq_style = this.is_expand ? {} : {height: 0};
  },
  methods: {
    toggleExpand: function () {
      this.is_expand = ! this.is_expand;
      if (this.is_expand) {
        this.faq_style = {height: this.computeHeight};
      } else {
        this.faq_style = {height: 0};
      }
      this.$emit('clicked', {id: this.category.id, expanded: this.is_expand})
    },
    calculateComputeHeight: function() {
      this.$refs['faqContentBox'].style.height = 'auto';
      this.$refs['faqContentBox'].style.position = 'absolute';
      this.$refs['faqContentBox'].style.visibility = 'hidden';
      this.$refs['faqContentBox'].style.display = 'block';

      this.computeHeight = getComputedStyle(this.$refs['faqContentBox']).height;

      this.$refs['faqContentBox'].style.position = null;
      this.$refs['faqContentBox'].style.visibility = null;
      this.$refs['faqContentBox'].style.display = null;
      this.$refs['faqContentBox'].style.height = this.is_expand ? this.computeHeight : 0;
    },
    recaculateComputeHeight: function() {
      if (!this.$refs['faqContentBox'].style.height || this.$refs['faqContentBox'].style.height == '0px') {
        this.calculateComputeHeight();
      } else {
        this.$refs['faqContentBox'].style.height = 'auto';
        this.$refs['faqContentBox'].style.position = 'absolute';
        this.$refs['faqContentBox'].style.visibility = 'hidden';
        this.$refs['faqContentBox'].style.display = 'block';

        this.computeHeight = getComputedStyle(this.$refs['faqContentBox']).height;

        this.$refs['faqContentBox'].style.height = this.computeHeight;
        this.$refs['faqContentBox'].style.position = null;
        this.$refs['faqContentBox'].style.visibility = null;
        this.$refs['faqContentBox'].style.display = null;
      }
    }
  },

  mounted: function() {
    // Only calculate height when created. If user click search or reset, force reload component by change key
    this.calculateComputeHeight();

    // Fix content broken by re-caculate when image is loaded
    let imgs = this.$refs['faqContentBox'].getElementsByTagName('img');
    for (let img of imgs) {
      img.onload = () => this.recaculateComputeHeight();
    }
  }
}
</script>

<style lang="scss" scoped>
.category-item {
  border: 1px solid darkgray;
  cursor: pointer;
  position: relative;
  margin-bottom: 10px;
  font-size: 14px;

  .md-icon {
    float: right;
  }

  .category {
    padding: 10px;
  }

  .category-name {
    flex-basis: 0;
    flex-grow: 1;
    line-height: 1.4;
    min-height: 24px;
  }

  .faqs {
    background: #EEEEEE;
    transition: 0.7s;
    height: 0;
    overflow: hidden;
  }

  .faq {
    padding: 0 20px;
    border-top: 1px solid darkgray;
    cursor: text;
  }

  .d-flex {
    display: flex;
  }

  .align-items-center {
    align-items: center;
  }

  .justify-content-between {
    justify-content: space-between;
  }

  .question {
    font-size: 18px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: #5F6E7E;
    color: white;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .answer {
    font-size: 18px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: rgb(97, 151, 214);
    color: white;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .question-content {
    margin: 5px 0 0 0;
    line-height: 1.5;
    flex-basis: 0;
    flex-grow: 1;
  }

  .answer-content {
    margin: 5px 0;
    flex-basis: 0;
    flex-grow: 1;
  }
  .answer-content ::v-deep(p:first-child) {
    margin: 0 0 8px 0;
  }
  .answer-content ::v-deep(p) {
    margin: 6px 0;
    font-size: 13px;
    line-height: 1.5;
  }

  .answer-content ::v-deep(img) {
    margin: 8px 0;
  }

  .answer-content ::v-deep(p br) {
    display: block;
    content: " ";
    margin: 1px 0;
  }
}
</style>
